import { Link, useNavigate } from "react-router-dom";
import { Fragment, useContext } from "react";
import { IoIosArrowForward } from "react-icons/io";
import { AuthContext } from "../../../Context/AuthContext";
import UserDataFetcher from "../../../libs/getUserbyUserId";
import { MARKET } from "../libs/marketplaceRoutes";
import { getMarketAccountMenu, MARKET_LOGIN_PATH } from "../libs/marketAccountMenu";
import "./UserProfile.css";

const MarketAccountDropdown = ({ variant = "desktop" }) => {
  const { isLoggedIn, Logout, user, authLoading } = useContext(AuthContext);
  const { adminData } = UserDataFetcher();
  const navigate = useNavigate();
  const profile = adminData?.user;
  const role = user?.role || profile?.role;
  const menu = getMarketAccountMenu(role);

  const handleLogOut = () => {
    Logout();
    navigate(MARKET.HOME);
  };

  const cardClass =
    variant === "mobile" ? "user-mobile-dropdown-card" : "user-dropdown-card";

  if (!isLoggedIn) {
    return (
      <div className={variant === "mobile" ? "user-mobile-drops" : undefined}>
        <div className={cardClass}>
          <Link to={MARKET_LOGIN_PATH}>
            <h3>Login/Signup</h3>
          </Link>
        </div>
      </div>
    );
  }

  if (authLoading && !profile?.first_name) {
    return (
      <div className={cardClass}>
        <p style={{ padding: "12px 16px", margin: 0, fontFamily: "Montserrat, sans-serif" }}>
          Loading account…
        </p>
      </div>
    );
  }

  return (
    <Fragment>
      {variant === "mobile" ? (
        <div className="user-mobile-drops">
          <div className={cardClass}>
            <div className="user-mobile-dropdown-con">
              <span>
                <h3>Hi,</h3>
                <h3>{profile?.first_name}</h3>
                <h3>{profile?.last_name}</h3>
              </span>
              <p>{profile?.email}</p>
              {menu.variant !== "customer" && (
                <p style={{ marginTop: 8, fontWeight: 600, color: "#284697" }}>{menu.title}</p>
              )}
            </div>
            <div className="wrapper">
              {menu.links.map(({ to, label, Icon }) => (
                <Link to={to} key={to}>
                  <span>
                    <Icon style={{ fontSize: "20px" }} />
                    {label}
                  </span>
                  <IoIosArrowForward />
                </Link>
              ))}
            </div>
            <button type="button" onClick={handleLogOut}>
              Logout
            </button>
          </div>
        </div>
      ) : (
        <div className={cardClass}>
          {menu.variant !== "customer" && (
            <p
              style={{
                margin: "8px 16px 0",
                fontFamily: "Montserrat, sans-serif",
                fontSize: 12,
                fontWeight: 600,
                color: "#284697",
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              {menu.title}
            </p>
          )}
          <span>
            {menu.links.map(({ to, label, Icon }) => (
              <Link to={to} key={to}>
                <Icon style={{ fontSize: "20px" }} />
                {label}
              </Link>
            ))}
          </span>
          <button type="button" onClick={handleLogOut}>
            Logout
          </button>
        </div>
      )}
    </Fragment>
  );
};

export default MarketAccountDropdown;
